<script>
    export default {
        props: {
            disk: {
                type: String,
                default: null
            },
            directory: {
                type: String,
                default: null
            },
            headline: {
                type: String,
                default: null
            },
            maxFiles: {
                type: Number,
                default: null
            },
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                token: Scoop.csrfToken,
                maxFilesize: Scoop.uploadMaxFilesize,
                uuid: Scoop.uuid,
                uploadedFiles: [],
            }
        },
        computed: {
            uploadUrl() {
                return this.baseUrl + '/scoop/upload';
            },
        },
        mounted() {
            this.initDropzone();
        },
        methods: {
            initDropzone() {
                Dropzone.options.filesUpload = {
                    vm: this,
                    maxFiles: this.maxFiles,
                    maxFilesize: this.maxFilesize,
                    timeout: 1800000,
                    init: function () {
                        this.on("success", (file) => {
                            let response = JSON.parse(file.xhr.response);

                            this.options.vm.uploadedFiles.push(response);

                            this.options.vm.$emit('file-uploaded', response);
                        });

                        this.on("queuecomplete", function () {
                            this.options.vm.$emit('all-files-uploaded',
                                _.mapValues(this.options.vm.uploadedFiles, 'filepath')
                            );
                        });
                    }
                };
            }
        },
    }
</script>

<template>
    <div class="ibox float-e-margins">
        <div class="ibox-title">
            <h5 v-text="headline || __('scoop-os.common.upload')"></h5>
        </div>
        <div class="ibox-content h-300">
            <form id="files-upload"
                  class="dropzone"
                  method="post"
                  :action="uploadUrl"
                  accept-charset="utf-8"
                  enctype="multipart/form-data">

                <input type="hidden" name="uuid" :value="uuid"/>
                <input type="hidden" name="disk" :value="disk"/>
                <input type="hidden" name="directory" :value="directory"/>
                <input type="hidden" name="_token" :value="token"/>
                <div class="dz-message" data-dz-message>
                    <div class="text text-center">
                        <i class="fa fa-cloud-upload fa-5x" aria-hidden="true"></i>
                        <h3 v-text="__('scoop-os.common.drop_to_upload')"></h3>
                    </div>
                </div>

            </form>
        </div>
    </div>
</template>

<style lang="scss">
    #files-upload {
        border: dashed 1px #ccc;
        min-height: 263px;
        line-height: 135px;

        .dz-message {
            color: #b5b5b5;
        }
    }
</style>